/**
 * sticky-atc.js — Sam's Store UAE v2
 * Upgraded: shows selected variant name + price in the sticky bar.
 * Clicks the sticky button → triggers native product-form submit.
 */
(function () {
    'use strict';

    var bar = document.getElementById('sticky-atc-bar');
    var stickyBtn = document.getElementById('sticky-atc-btn');
    if (!bar || !stickyBtn) return;

    var nativeBtn = document.querySelector(
        '#MainContent .product-form__submit, #MainContent [name="add"]'
    );
    if (!nativeBtn) return;

    /* ── Elements to update ── */
    var nameEl = bar.querySelector('.sticky-atc-bar__name');
    var priceEl = bar.querySelector('.sticky-atc-bar__price');
    var variantEl = bar.querySelector('.sticky-atc-bar__variant');

    /* ── Read selected variant info from Dawn's variant JSON ── */
    function updateVariantInfo() {
        try {
            /* Dawn writes current variant to data-current-variant or a hidden input */
            var variantIdInput = document.querySelector(
                '#MainContent input[name="id"], #MainContent .product-variant-id'
            );
            if (!variantIdInput) return;

            var variantId = variantIdInput.value;
            var productJson = document.querySelector('[data-product-json], #ProductJson-product-template');
            if (!productJson) return;

            var product = JSON.parse(productJson.textContent || productJson.innerText);
            var variant = product.variants.find(function (v) { return String(v.id) === String(variantId); });
            if (!variant) return;

            /* Build variant label (skip "Default" placeholder) */
            var options = variant.options || [];
            var label = options.filter(function (o) { return o && o.toLowerCase() !== 'default title'; }).join(' / ');

            if (variantEl) {
                variantEl.textContent = label || '';
                variantEl.style.display = label ? '' : 'none';
            }

            /* Price */
            if (priceEl && variant.price != null) {
                var money = (variant.price / 100).toFixed(2);
                /* Use shop currency — read from meta if available */
                var currency = document.querySelector('meta[name="shop-currency"]');
                priceEl.textContent = (currency ? currency.content : 'AED') + ' ' + money;
            }

            /* Availability */
            stickyBtn.disabled = !variant.available;
            stickyBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
        } catch (e) { /* silent */ }
    }

    /* ── Show bar when native ATC scrolls out of view ── */
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                bar.classList.remove('is-visible');
                bar.setAttribute('aria-hidden', 'true');
            } else {
                bar.classList.add('is-visible');
                bar.setAttribute('aria-hidden', 'false');
            }
        });
    }, { threshold: 0.5 });

    observer.observe(nativeBtn);

    /* ── Proxy click to native ATC ── */
    stickyBtn.addEventListener('click', function () {
        nativeBtn.click();
    });

    /* ── Listen for variant changes (Dawn dispatches 'change' on variant select/swatch) ── */
    updateVariantInfo(); // initial
    document.addEventListener('change', function (e) {
        var t = e.target;
        if (!t) return;
        if (t.name === 'id' || t.closest('[data-variant-select], .product-form')) {
            setTimeout(updateVariantInfo, 80); // small delay for Dawn to update
        }
    });

    /* Also listen for Dawn's custom variant:change event */
    document.addEventListener('variant:change', updateVariantInfo);
})();
